module.exports = __webpack_public_path__ + "img/Murmeli0.67114a88.gif";